export type UseStartTestButtonStateProps = {
  readonly email?: string;
  readonly hasSuitableAppConfigurationSelected?: boolean;
  readonly isCreditsExpired?: boolean;
  readonly isInUse?: boolean;
  readonly isLocked?: boolean;
  readonly isManualMinutesExpired?: boolean;
  readonly unverified?: boolean;
};

type UseStartTestButtonStateReturn = {
  readonly enableAdvise: string;
  readonly isButtonDisabled: boolean;
  readonly isDevicePermitted: boolean;
}

// this is not a hook but a simple util
// unless we start to get some props from the store via other selectors
// TODO: revisit if that should be done or move it to utils
const useStartTestButtonState = ({
  email = '',
  hasSuitableAppConfigurationSelected = true,
  isCreditsExpired = false,
  isInUse = false,
  isLocked = false,
  isManualMinutesExpired = false,
  unverified = false,
}: UseStartTestButtonStateProps): UseStartTestButtonStateReturn => {
  const isDevicePermitted = !isLocked && !unverified &&
    !isManualMinutesExpired && !isCreditsExpired &&
    // special case where we don't want to display the corresponding button tooltip
    // if the device is in use
    (isInUse || hasSuitableAppConfigurationSelected);
  const isButtonDisabled = !isDevicePermitted || isInUse;
  let enableAdvise = '';

  if (unverified) { // cases for unverified email address
    if (email) {
      enableAdvise = `To use this device for testing, verify the email we sent to ${email}`;
    }
    enableAdvise = 'To use this device for testing, verify your email.';
  } else if (isLocked) { // case for the account not having access rights to the device
    enableAdvise = 'Upgrade your account to use this device.';
  } else if (isManualMinutesExpired) { // case for expired testing minutes
    enableAdvise = 'To keep testing, upgrade now for unlimited minutes.';
  } else if (isCreditsExpired) {
    enableAdvise = 'To keep testing, upgrade now for more credits.';
  } else if (!hasSuitableAppConfigurationSelected) { // case for not having a an app/build selected
    enableAdvise = 'Select an application before starting the test.';
  }

  return {
    enableAdvise,
    isButtonDisabled,
    isDevicePermitted,
  };
};

export { useStartTestButtonState };
